import { posthogConfig } from '@/config/posthog';
import posthog from 'posthog-js';

const POSTHOG_KEY = posthogConfig.apiKey;
const POSTHOG_HOST = posthogConfig.apiHost;

if (!POSTHOG_KEY || !POSTHOG_HOST) {
  console.warn('PostHog not initialized: Missing API key or host');
} else {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
  });
}

export const trackEvent = (eventName: string, properties = {}) => {
  posthog.capture(eventName, properties);
};

export const identifyUser = (userId: string, userProps = {}) => {
  posthog.identify(userId, userProps);
};

export const resetUser = () => {
  posthog.reset();
};
